import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { blastKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useBlastDetail = (blastId, pollFn) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryKey: blastKeys.detail(blastId),
        queryFn: () => axios.get(markUrl('blasts/detail/'), {
            ...additional,
            params: { blast_id: blastId }
        }),
        staleTime: 30_000,
        enabled: blastId > 0,
        refetchInterval: pollFn ? (query) => pollFn(query.state.data?.data?.status) : false
    });
};
export default useBlastDetail;
